module.exports = __webpack_public_path__ + "static/media/04.7a24fe5d.wav";